import { createTheme } from "@mui/material";
import Colors from "./tokens/colors";

export const pagarmeTheme = createTheme({
  typography: {
    fontFamily: ["Lato", "Poppins", "sans-serif"].join(","),
    body1: {
      fontSize: 16,
      lineHeight: 1.5, //rem
      fontWeight: 400,
      fontFamily: `'Lato', sans-serif`,
      color: "#454550",
    },
    h1: {
      fontSize: 32,
      lineHeight: 1.5, //rem
      fontWeight: 400,
      fontFamily: `'Poppins', sans-serif`,
      color: "#2A2A2A", //BASE BLACK
    },
  },
  palette: {
    primary: {
      light: Colors.CONTEXT_PRIMARY_50,
      main: Colors.CONTEXT_PRIMARY_100,
      dark: Colors.CONTEXT_PRIMARY_200,
    },
    secondary: {
      light: Colors.CONTEXT_SECONDARY_50,
      main: Colors.CONTEXT_SECONDARY_100,
      dark: Colors.CONTEXT_SECONDARY_200,
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {},
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          fontSize: 16,
        },
        standardSuccess: {
          color: Colors.CONTEXT_SUCCESS_200,
        },
        standardError: {
          color: Colors.CONTEXT_DANGER_200,
        },
      },
      variants: [
        {
          props: { variant: "success", icon: false },
          style: {
            backgroundColor: Colors.CONTEXT_DANGER_20,
            borderRadius: 4,
          },
        },
        {
          props: { variant: "error" },
          style: {
            backgroundColor: Colors.CONTEXT_DANGER_20,
            borderRadius: 4,
          },
        },
      ],
    },
  },
});
